module.exports = __webpack_public_path__ + "static/img/ls.04bf275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/doctor/ls.jpg
// module id = x4hG
// module chunks = 1